export default /^[^@ ]+@[^\\. ]+\..+$/;
